// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Night Owl, by Sarah Drasner (MIT) — https://github.com/sdras/night-owl-vscode-theme
 *
 * The Monaco editor theme lives in src/language/night-owl-theme.ts. These
 * variables retint PrimeReact's lara-dark-blue chrome to the same palette so the
 * editor doesn't sit in a differently-coloured shell.
 */
:root {
  --night-owl-bg: #011627;
  --night-owl-bg-raised: #0b2942;
  --night-owl-bg-hover: #084d81;
  --night-owl-border: #1d3b53;
  --night-owl-fg: #d6deeb;
  --night-owl-fg-muted: #637777;
  --night-owl-accent: #7fdbca;
  --night-owl-accent-alt: #82aaff;

  --surface-ground: var(--night-owl-bg);
  --surface-section: var(--night-owl-bg);
  --surface-card: var(--night-owl-bg-raised);
  --surface-overlay: var(--night-owl-bg-raised);
  --surface-border: var(--night-owl-border);
  --surface-hover: var(--night-owl-bg-hover);
  --surface-a: var(--night-owl-bg);
  --surface-b: var(--night-owl-bg);
  --surface-c: var(--night-owl-bg-hover);
  --surface-d: var(--night-owl-border);
  --surface-e: var(--night-owl-bg-raised);
  --surface-f: var(--night-owl-bg-raised);

  --text-color: var(--night-owl-fg);
  --text-color-secondary: var(--night-owl-fg-muted);
  --primary-color: var(--night-owl-accent);
  --primary-color-text: var(--night-owl-bg);
  --highlight-bg: var(--night-owl-bg-hover);
  --highlight-text-color: var(--night-owl-fg);
}

body {
  margin: 0;
  font-family: var(--font-family);
  background-color: var(--night-owl-bg);
  color: var(--night-owl-fg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;;EAE/B,qCAAqC;EACrC,sCAAsC;EACtC,0CAA0C;EAC1C,6CAA6C;EAC7C,yCAAyC;EACzC,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;EACtC,oCAAoC;EACpC,uCAAuC;EACvC,uCAAuC;;EAEvC,iCAAiC;EACjC,iDAAiD;EACjD,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb","sourcesContent":["/*\n * Night Owl, by Sarah Drasner (MIT) — https://github.com/sdras/night-owl-vscode-theme\n *\n * The Monaco editor theme lives in src/language/night-owl-theme.ts. These\n * variables retint PrimeReact's lara-dark-blue chrome to the same palette so the\n * editor doesn't sit in a differently-coloured shell.\n */\n:root {\n  --night-owl-bg: #011627;\n  --night-owl-bg-raised: #0b2942;\n  --night-owl-bg-hover: #084d81;\n  --night-owl-border: #1d3b53;\n  --night-owl-fg: #d6deeb;\n  --night-owl-fg-muted: #637777;\n  --night-owl-accent: #7fdbca;\n  --night-owl-accent-alt: #82aaff;\n\n  --surface-ground: var(--night-owl-bg);\n  --surface-section: var(--night-owl-bg);\n  --surface-card: var(--night-owl-bg-raised);\n  --surface-overlay: var(--night-owl-bg-raised);\n  --surface-border: var(--night-owl-border);\n  --surface-hover: var(--night-owl-bg-hover);\n  --surface-a: var(--night-owl-bg);\n  --surface-b: var(--night-owl-bg);\n  --surface-c: var(--night-owl-bg-hover);\n  --surface-d: var(--night-owl-border);\n  --surface-e: var(--night-owl-bg-raised);\n  --surface-f: var(--night-owl-bg-raised);\n\n  --text-color: var(--night-owl-fg);\n  --text-color-secondary: var(--night-owl-fg-muted);\n  --primary-color: var(--night-owl-accent);\n  --primary-color-text: var(--night-owl-bg);\n  --highlight-bg: var(--night-owl-bg-hover);\n  --highlight-text-color: var(--night-owl-fg);\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-family);\n  background-color: var(--night-owl-bg);\n  color: var(--night-owl-fg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
